import { z } from "zod";
import { getOrderParamSchema } from "./get-order.schema";

export const getSuborderParamSchema = z
	.object({
		suborderId: z.uuid(),
	})
	.and(getOrderParamSchema);

export type GetSuborderParamSchema = z.infer<typeof getSuborderParamSchema>;

export const patchSuborderStateQuerySchema = z.object({
	direction: z.enum(["forward", "back"]).optional(),
	role: z.enum(["picker", "manager"]),
});

export type PatchSuborderStateQuerySchema = z.infer<typeof patchSuborderStateQuerySchema>;
